"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>PennyExpandableInput
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_react_namespaceObject = require("react");
const analytics_js_namespaceObject = require("../../analytics/analytics.js");
var analytics_js_default = /*#__PURE__*/ __webpack_require__.n(analytics_js_namespaceObject);
const ChatbotDataContext_js_namespaceObject = require("../../context/ChatbotDataContext.js");
const useChatMessagesContext_js_namespaceObject = require("../../hooks/useChatMessagesContext.js");
const useChatUIContext_js_namespaceObject = require("../../hooks/useChatUIContext.js");
const useLoadingStateContext_js_namespaceObject = require("../../hooks/useLoadingStateContext.js");
const useRealTimeContext_js_namespaceObject = require("../../hooks/useRealTimeContext.js");
const external_submitChatMessages_js_namespaceObject = require("../../submitChatMessages.js");
const ChatSendIcon_js_namespaceObject = require("../../svgs/ChatSendIcon.js");
var ChatSendIcon_js_default = /*#__PURE__*/ __webpack_require__.n(ChatSendIcon_js_namespaceObject);
const sanitizeInput_js_namespaceObject = require("../../utils/sanitizeInput.js");
var sanitizeInput_js_default = /*#__PURE__*/ __webpack_require__.n(sanitizeInput_js_namespaceObject);
const ExpandableInput_js_namespaceObject = require("../ExpandableInput/ExpandableInput.js");
const VoiceControlButton_js_namespaceObject = require("../Realtime/VoiceControlButton/VoiceControlButton.js");
var VoiceControlButton_js_default = /*#__PURE__*/ __webpack_require__.n(VoiceControlButton_js_namespaceObject);
const PennyExpandableInput_PennyExpandableInput = ({ submitChatMessagesOptions, styles, handleExpandableInputHeight, isRealtime })=>{
    const { submitChatMessagesPayload, setErrorMessage, logFirstMessageSubmitted } = (0, external_react_namespaceObject.useContext)(ChatbotDataContext_js_namespaceObject.ChatbotDataContext);
    const { isLoading } = (0, useLoadingStateContext_js_namespaceObject.useLoadingStateContext)();
    const { setOpenErrorComponent } = (0, useChatUIContext_js_namespaceObject.useChatUIContext)();
    const { chatMessages, setChatMessages } = (0, useChatMessagesContext_js_namespaceObject.useChatMessagesContext)();
    const { setStartRealTime } = (0, useRealTimeContext_js_namespaceObject.useRealTimeContext)();
    const VoiceIcon = isRealtime ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(VoiceControlButton_js_default(), {
        isExpandableTextArea: true
    }) : null;
    const SendIcon = /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ChatSendIcon_js_default(), {});
    const inputBoxStyle = {
        padding: '8px',
        ...styles.inputStyle,
        ...'style' in styles.inputStyle ? styles.inputStyle?.style : {}
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
        style: inputBoxStyle,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ExpandableInput_js_namespaceObject.ExpandableInput, {
            placeholder: 'Ask Penny a Question',
            variant: 'glow',
            maxLineHeight: 3,
            voiceIcon: VoiceIcon,
            submitIcon: SendIcon,
            disabled: isLoading,
            onSubmitClickHandler: function(msg) {
                setErrorMessage('');
                const chatMessage = {
                    role: 'user',
                    content: sanitizeInput_js_default()(msg),
                    date: new Date()
                };
                const promptMessage = {
                    role: 'user',
                    content: sanitizeInput_js_default()(msg)
                };
                const updatedChatMessages = [
                    ...chatMessages,
                    chatMessage
                ];
                setChatMessages([
                    ...chatMessages,
                    chatMessage
                ]);
                (0, external_submitChatMessages_js_namespaceObject.submitChatMessages)({
                    submitChatMessagesPayload: {
                        ...submitChatMessagesPayload,
                        prompts: [
                            promptMessage
                        ],
                        includeSpeech: true
                    },
                    setOpenErrorComponent,
                    chatMessages: updatedChatMessages,
                    ...submitChatMessagesOptions
                })?.catch((e)=>analytics_js_default().logError({
                        message: e?.message,
                        source: 'PennyExpandableInput submitChatMessages'
                    }));
                logFirstMessageSubmitted(chatMessages);
            },
            onVoiceClickHandler: function() {
                setStartRealTime(true);
            },
            voiceIconClassName: "mr-2",
            submitIconClassName: "",
            onHeightChange: handleExpandableInputHeight
        })
    });
};
const PennyExpandableInput = PennyExpandableInput_PennyExpandableInput;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
